// eslint-disable-next-line
import whatInput from 'what-input';
import HeaderScrolled from './headerScrolled';
import MenuButton from './menuButton';
import FixedBanner from './fixedBanner';
import HoverNavigation from './hoverNavigation';
import Accordion from './accordion';
import MainVisual from './mainVisual';
import Slider from './slider';
import Concept from './concept';
import FooterNav from './footerNav';

window.onload = () => {
  const preload = document.getElementsByClassName('preload');
  preload[0].classList.remove('preload');
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('js-header') !== null) {
    const headerScrolled = new HeaderScrolled();
    headerScrolled.init();
  }
  if (document.getElementById('js-menuButton') !== null) {
    const menuButton = new MenuButton();
    menuButton.init();
  }
  if (document.getElementById('js-globalNav') !== null) {
    const hoverNavigation = new HoverNavigation();
    hoverNavigation.init();
  }
  if (document.getElementById('js-mainVisual') !== null) {
    const mainVisual = new MainVisual();
    mainVisual.init();
  }
  if (document.getElementById('js-concept') !== null) {
    const concept = new Concept();
    concept.init();
  }
  if (document.getElementsByClassName('js-challengeSlider').length > 0) {
    const challengeSlider = new Slider();
    challengeSlider.challenge('.js-challengeSlider');
  }
  if (document.getElementById('js-voiceSlider') !== null) {
    const voiceSlider = new Slider();
    voiceSlider.voice('#js-voiceSlider');
  }
  if (document.getElementById('js-accordion') !== null) {
    const accordion = new Accordion();
    accordion.init();
  }
  if (document.getElementById('js-fixedBanner') !== null) {
    const fixedBanner = new FixedBanner();
    fixedBanner.init();
  }
  if (document.getElementById('js-zohoSubmit') !== null) {
    document.getElementById('js-zohoSubmit').addEventListener('click', () => {
      if (window.zf_ValidateAndSubmit()) {
        document.getElementById('form').submit();
      }
    });
  }

  if (document.getElementsByClassName('js-inView').length > 0) {
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-viewed');
        }
      });
    };
    const option = {
      rootMargin: '-100px',
    };
    const io = new IntersectionObserver(callback, option);
    const targets = document.querySelectorAll('.js-inView');
    targets.forEach((target) => {
      io.observe(target);
    });
  }

  if (document.getElementById('footerNav') !== null) {
    const footerNav = new FooterNav();
    footerNav.init();
  }
});
